module.exports = __webpack_public_path__ + "static/media/sony_micro.25477c87.JPG";